import { makeStyles, createStyles } from "@material-ui/styles"

const useStyles = makeStyles(theme =>
  createStyles({
    title: {
      display: "flex",
      justifyContent: "center",
      paddingTop: "40px",
    },
    dialogPaper: {
      width: "100%",
    },
    listItem: {
      marginLeft: theme.spacing(2),
      marginTop: theme.spacing(1.5),
    },
    actions: {
      justifyContent: "center",
    },
    buttons: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      width: "85%",
    },
  })
)

export default useStyles
